import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AbstractDialogComponent } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyContact } from 'src/app/core/model/lenovo/company-contact';

@Component({
  selector: 'app-edit-company-contact-dialog',
  templateUrl: './edit-company-contact-dialog.component.html',
  styleUrls: ['./edit-company-contact-dialog.component.scss'],
})
export class EditCompanyContactDialogComponent extends AbstractDialogComponent implements OnInit {
  contact: CompanyContact;
  formGroup: UntypedFormGroup;
  constructor(public activeModal: NgbActiveModal, public formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 0) {
      this.contact = this.inputs[0];

      this.formGroup = this.formBuilder.group({
        id: [this.contact.id],
        companyId: [this.contact.companyId],
        firstName: [this.contact.firstName, [Validators.required, Validators.maxLength(256)]],
        lastName: [this.contact.lastName, [Validators.required, Validators.maxLength(256)]],
        email: [this.contact.email, [Validators.required, Validators.maxLength(256), Validators.email]],
      });
    }
  }

  onClose() {
    this.activeModal.close('cancel');
  }

  onSubmit() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.activeModal.close({ button: 'submit', contact: this.formGroup.value });
    }
  }
}
